module.exports = __webpack_public_path__ + "static/media/icon-error-circle.1bd207eb.svg";